


































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { GetSqlTemps } from "@/api/systemBasic";

@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;

  sqlList: any = [];
  form: any = {};

  rules: any = {
    sqlMaintainName: [{ required: true, message: "请选择", trigger: "blur" }],
    itemType: [{ required: true, message: "请选择", trigger: "blur" }],
  };

  created() {
    this.getData();
    this.form = Object.assign({}, this.data.moduleInfo);
  }

  async getData() {
    let res = await GetSqlTemps({});
    this.sqlList = res.objects;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        let sqlMaintain = this.sqlList.find(
          (x) => x.name == this.form.sqlMaintainName
        );
        this.$emit("save-success", {
          sqlName: sqlMaintain.name,
          itemType: this.form.itemType,
          itemPosition: this.form.itemPosition,
        });
        this.$emit("input", false);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/biReport/sqlSelect.vue